import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  //   OnInit,
} from "@angular/core";

@Directive({
  selector: "[hasLicense]",
})
export class HasLicenseDirective {
  private requiredLicenses: string[] = [];
  private elseTemplate: TemplateRef<any> | null = null;

  constructor(private tpl: TemplateRef<any>, private vcr: ViewContainerRef) {}

  @Input()
  set hasLicense(licenses: string[]) {
    this.requiredLicenses = licenses;
    this.updateView();
  }

  @Input()
  set hasLicenseElse(template: TemplateRef<any>) {
    this.elseTemplate = template;
    this.updateView();
  }

  private updateView() {
    const tenantData = JSON.parse(localStorage.getItem("permission") || "{}");
    const tenantLicenses: string[] = tenantData?.tenant_licenses || [];

    const licensed = this.requiredLicenses.every((l) =>
      tenantLicenses.includes(l)
    );

    this.vcr.clear();

    if (licensed) {
      this.vcr.createEmbeddedView(this.tpl);
    } else if (this.elseTemplate) {
      this.vcr.createEmbeddedView(this.elseTemplate);
    }
  }
}
